<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     文件上传组件
  +---------------------------------------------------------------------------------------
-->

<template>
	<el-dialog custom-class="file-upload" :visible.sync="dialogShow" width="600px" :close-on-click-modal="false" :modal-append-to-body="false">
		<span slot="title">
			<span class="font-md title">{{ fileObject.title }}</span>
		</span>
		<div class="flex-center column">
			<template v-if="!uploadFail && !parsing && !uploadSuccess" name="el-zoom-in-center">
				<div class="mb flex-center align-items-center">
					{{ fileObject.templeteDecription[0] }}
					<el-link v-if="fileObject.TempleteUrl" type="primary" style="margin: 0px 4px" :href="fileObject.TempleteUrl"> {{ fileObject.templeteDecription[1] }}</el-link>
					<span v-else> {{ fileObject.templeteDecription[1] }}</span>
					{{ fileObject.templeteDecription[2] }}
				</div>
				<el-upload v-loading="uploading" drag :accept="fileObject.fileType" :action="$store.state.commonStore.fileUploadUrl" :show-file-list="false" :multiple="false" :before-upload="beforeUpload" :on-change="onExceed" :on-error="handleUploadFail" :on-success="handleUploadSuccess">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">
						<div class="mb">{{ '将 ' + fileObject.types + ' 文件拖拽至此处，或' }}</div>
						<!-- <slot name="tip"></slot> -->
						<el-button type="primary" size="mini">点击上传</el-button>
					</div>
				</el-upload>
			</template>

			<template v-if="parsing">
				<img class="parse-img" src="@/assets/parse.gif" />
				<div class="font-md">正在解析数据······</div>
			</template>

			<template v-if="uploadSuccess">
				<b class="font-lg text-success">导入成功</b>
				<div class="mt">
					{{ '共导入 ' + successNum + ' 条数据' }}
				</div>
				<el-button class="mt-hg extend" type="primary" @click="dialogShow = false">确定</el-button>
			</template>

			<template v-if="uploadFail">
				<b class="font-lg text-warning">导入失败</b>
				<div class="mt">
					<div v-for="(item, index) in uploadFailReason" :key="index" class="text-danger">{{ item }}</div>
				</div>
				<el-button class="mt" plain size="mini" @click="resetUpload">重新上传</el-button>
			</template>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'FileUpload',

	props: {
		show: {
			type: Boolean,
			default: false
		},
		fileObject: {
			type: Object,

			//传入模板
			// default: {
			// 	title: '上传文件',
			// 	fileType: '.xls,.xlsx',
			// 	types: 'Excel',
			// 	templeteDecription: ['支持 ', ' 标准模板 Excel ', ' 导入模型'],
			// 	TempleteUrl: process.env.VUE_APP_API_HOST_URL
			// }
		}
	},

	data () {
		return {
			posting: false,
			uploading: false,
			uploadFail: true,
			uploadSuccess: false,
			parsing: false,
			uploadFailReason: [],
			successNum: 0
		}
	},

	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		}
	},

	created () { },

	methods: {
		handleSelectChange (idx) {
			this.currentCreateMethod = idx
		},

		onExceed (file, fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1)
			}
		},

		beforeUpload (file) {
			this.uploading = true
			return true
		},

		handleUploadFail (err, file, fileList) {
			// console.log('文件上传失败')
			this.uploading = false
			this.$message.error('文件上传失败')
		},
		handleUploadSuccess (response, file, fileList) {
			if (!response.errno) {
				this.parsing = true
				importSimApi({ fileid: response.data.id }).then(res => {
					this.parsing = false
					this.uploading = false
					if (!res.errno) {
						this.uploadSuccess = true
						// this.$message.success('数据导入成功，共' + this.fileObject.title + ' 5 条')
						this.$emit('submit')
						// this.dialogShow = false
					} else {
						this.uploadFail = true
						this.uploadFailReason = res.data
					}
				})
			} else {
				this.uploading = false
				this.$message.error(response.message)
			}
		},

		resetUpload () {
			this.uploadSuccess = false
			this.uploadFail = false
			this.uploadFailReason = []
		}
	}
}
</script>

<style lang="scss">
.file-upload {
	.parse-img {
		height: 194px;
	}
}
</style>
